import { Directive, ElementRef, HostListener, Input, EventEmitter, Output, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { Validator, FormControl, NG_VALIDATORS } from '@angular/forms';
import { CommonService } from '@service/common.service';

@Directive({
    // tslint:disable-next-line: directive-selector
    selector: '[matInput]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: TextboxDirective, multi: true },
    ]
})
export class TextboxDirective implements Validator {

    @Input() maximumlength: string;

    constructor(private elementRef: ElementRef, private service: CommonService) {
    }

    validate(control: FormControl) {
        if (!control || !control.value) {
            return null;
        }
        return this.validateTextbox(control.value);
    }

    validateTextbox(value) {
        try {
            const invalidWhiteSpace = this.checkWhiteSpace(value);
            if (invalidWhiteSpace) {
                return invalidWhiteSpace;
            }
            const invalidMaxlength = this.checkMaxLength(value);
            if (invalidMaxlength) {
                return invalidMaxlength;
            }
        } catch (ex) {
            console.error(`validateTextbox exception ${ex.toString()}`);
        }
    }

    checkWhiteSpace(currentValue) {
        try {
            if (!currentValue) {
                return null;
            }
            const text = this.service.toTrim(currentValue);
            return text ? null : Object.assign({}, { whitespace: true });
        } catch (ex) {
            throw Error(ex);
        }
    }

    checkMaxLength(currentValue) {
        try {
            if (!this.maximumlength || !currentValue) {
                return null;
            }
            return currentValue.length > parseInt(this.maximumlength, null) ? Object.assign({}, { maximumlength: true }) : null;
        } catch (ex) {
            throw Error(ex);
        }
    }
}
